module.exports = __webpack_public_path__ + "static/media/icon_success.7881ef4d.svg";